// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"72531c93","796":"49e3c2de"}[chunkId] + ".chunk.js";
};